import React, { forwardRef, useState } from "react";

type Props = React.InputHTMLAttributes<HTMLInputElement>;

const formatCep = (value: string) => {
  const digits = value.replace(/\D/g, "").slice(0, 8); // Limita a 8 dígitos
  return digits.replace(/^(\d{5})(\d)/, "$1-$2");
};

export const MaskedInputCep = forwardRef<HTMLInputElement, Props>(({ onChange, ...props }, ref) => {
  const [value, setValue] = useState(props.value);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    const masked = formatCep(raw);
    setValue(masked);

    const syntheticEvent = {
      ...e,
      target: {
        ...e.target,
        value: masked,
      },
    };

    onChange?.(syntheticEvent as React.ChangeEvent<HTMLInputElement>);
  };

  return (
    <input
      {...props}
      ref={ref}
      value={value}
      onChange={handleChange}
      maxLength={9} // 8 números + 1 hífen
      inputMode="numeric"
    />
  );
});

MaskedInputCep.displayName = "MaskedInputCep";
